import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import {
  BLUE,
  GREEN,
  MessageCount,
  MessageWrapper,
  RED,
  WHITE,
} from '../Styles';
import { ExpandCollapseDataButton } from './ExpandCollapseDataButton';

export const MessageCountInfo = observer(() => {
  const {
    DebuggerStore: { errorsExistInLog, logCount },
  } = useStores();

  const totalMessageCount = logCount;
  const errorMessageCount = errorsExistInLog || 0;
  const infoMessageCount = totalMessageCount - errorMessageCount;
  const hasData = totalMessageCount > 0;

  const counts = [
    {
      bgColor: BLUE,
      color: WHITE,
      count: totalMessageCount,
    },
    {
      bgColor: GREEN,
      color: WHITE,
      count: infoMessageCount,
    },
    {
      bgColor: RED,
      color: WHITE,
      count: errorMessageCount,
    },
  ];

  if (!hasData) return null;
  
  // todo: make the badges clickable and act as filters
  return (
    <MessageWrapper>
      {counts.map(({ bgColor, color, count }, index) => (
        <MessageCount bgColor={bgColor} color={color} key={`message-count-${index}`}>
          {count}
        </MessageCount>
      ))}
      <ButtonWrapper>
        <ExpandCollapseDataButton />
      </ButtonWrapper>
    </MessageWrapper>
  );
});

export default MessageCountInfo;

const ButtonWrapper = styled.div`
  && ${MessageWrapper} {
    height: 40px;
  }
`;
